/* eslint-disable */

import Progress from '@/components/@order/Progress'
import { minTime } from '@/utils/formatDate'
import { computed } from '@vue/composition-api'

export default ({
  props: {
    works: Array,
    data: Object,
  },
  components: {
    Progress,
  },
  setup(props) {
    const panels = [Array.from(Array(props.works.length).keys())]
    const getTime = time => minTime(new Date(time))

    const getSpendTime = (totalMinutes) => {
      const hours = Math.floor(totalMinutes / 60) || 0
      const minutes = Math.ceil(totalMinutes % 60)
      const hoursStr = hours || !minutes ? `${hours}ч.` : ''
      const minutesStr = minutes ? `${minutes}м.` : ''
      return `${hoursStr} ${minutesStr}`
    }


    const removeStartBreaks = (workProcess) => {
      for (let i = 0; i < workProcess.length; i += 1) {
        if (workProcess[i].type === 'Break') {
          workProcess.splice(i, 1)
          i -= 1
        } else {
          return
        }
      }
    }
    const getMachineHours = (totalMinutes) => {
      const hours = Math.floor(totalMinutes / 60) || 0
      const minutes = Math.ceil(totalMinutes % 60)
      return  minutes >= 10 ? hours + 1 : hours
    }
    const machineHours = computed(() => {
      const items = props.works
      const workProcess = items.map(el => el.workProcess.map(q => q.diffMinutes))
      const diffMinutes = workProcess.map(q => q.filter(Boolean).reduce((acc, val) => acc + val, 0))
      return diffMinutes.map(el => getMachineHours(el))
    })

    const getOrderWorks = (work) => {
      const { workProcess } = work
      removeStartBreaks(workProcess)

      return workProcess
        .map((item, index, array) => {
          if (item.type === 'Break') {
            return item
          }
          const isAdditionalHour = item.type === 'AdditionalMachineHour'
          let startTitle = array[index - 1]?.type === 'Break' ? 'Возобновление:' : 'Начало работы:'
          const endTitle = array[index + 1]?.type === 'Break' ? 'Технический перерыв:' : 'Завершение работы:'

          if (isAdditionalHour) {
            startTitle = 'Время до объекта:'
          }

          return {
            type: item.type,
            isAdditionalHour,
            start: {
              title: startTitle,
              time: getTime(item.timeStart),
            },
            end: {
              title: !!item.timeEnd ? endTitle : 'В работе',
              time: !!item.timeEnd ? getTime(item.timeEnd) : '',
            },
            time: getSpendTime(item.diffMinutes),
          }
        })
    }
    return {
      panels,
      getOrderWorks,
      machineHours,
    }
  },
})
